module.exports = __webpack_public_path__ + "img/26-scarf.062e04ba.jpg";